import { defineMessages } from "react-intl";

const PREFIX = "AuthPage";
export default defineMessages({
  header: {
    id: `${PREFIX}.header`,
    defaultMessage: "Sign in",
  },
  loginButton: {
    id: `${PREFIX}.loginButton`,
    defaultMessage: "Log in",
  },
  register: {
    id: `${PREFIX}.register`,
    defaultMessage: "Register",
  },
  errorMessage: {
    id: `${PREFIX}.errorMessage`,
    defaultMessage: "Please, check the correctness of the entered data",
  },
  login: {
    id: `${PREFIX}.login`,
    defaultMessage: "E-mail",
  },
  password: {
    id: `${PREFIX}.password`,
    defaultMessage: "Password",
  },
  resetHeader: {
    id: `${PREFIX}.resetHeader`,
    defaultMessage: "Forgot Password",
  },
  resetConent: {
    id: `${PREFIX}.resetConent`,
    defaultMessage:
      "Lost your password? Please enter your email address. You will receive a link to create a new password via email.",
  },
  resetFormInputLabel: {
    id: `${PREFIX}.resetForm.input.label`,
    defaultMessage: "Enter your email adress",
  },
  resetSubmit: {
    id: `${PREFIX}.resetSubmit`,
    defaultMessage: "Submit",
  },
  forgotPassword: {
    id: `${PREFIX}.forgotPassword`,
    defaultMessage: "Forgot password?",
  },
  serverError: {
    id: `${PREFIX}.serverError`,
    defaultMessage: "Sorry, something went wrong. Please try later",
  },
  
  resetPasswordEmailNoExistsError: {
    id: `${PREFIX}.resetPasswordEmailNoExistsError`,
    defaultMessage: "Sorry, Email is not registered. We have sent a link to register",
  },
});
